import React, { useEffect, useState } from 'react'

import styles from './styles.module.css'

type TimerFormat = 'letter' | 'number'
interface Props {
  initialDuration: number | null
  format?: TimerFormat
}

const computeTimeString = (value: number) => `${String(value).length === 1 ? '0' : ''}${value}`
const computeTimeObject = (duration: number, format: TimerFormat) => {
  const second = Math.floor((duration / 1000) % 60)
  const minute = Math.floor((duration / 1000 / 60) % 60)
  const hour = Math.floor((duration / 1000 / 3600) % 24)
  if (format === 'number') {
    return {
      hour: computeTimeString(hour),
      minute: computeTimeString(minute),
      second: computeTimeString(second),
    }
  }
  return { hour, minute, second }
}

const Timer: React.FC<Props> = ({ initialDuration, format = 'letter' }): JSX.Element => {
  const [time, setTime] = useState(() => {
    if (initialDuration) {
      return computeTimeObject(initialDuration, format)
    }
    return { hour: undefined, minute: undefined, second: undefined }
  })
  const [counter, setCounter] = useState(initialDuration ?? 0)
  const [isActive] = useState(true)

  useEffect(() => {
    let intervalId: any

    if (isActive) {
      intervalId = setInterval(() => {
        setTime(computeTimeObject(counter, format))
        setCounter((counter) => counter + 1000)
      }, 1000)
    }

    return () => clearInterval(intervalId)
  }, [counter, format, isActive])

  if (format === 'number') {
    return (
      <div className={styles.time}>
        <span>{`${time.hour}:`}</span>
        <span>{`${time.minute}:`}</span>
        <span>{`${time.second}`}</span>
      </div>
    )
  }

  return (
    <div className={styles.time}>
      {!!time.hour && <span>{`${time.hour}h `}</span>}
      {!!time.minute && <span>{`${time.minute}m `}</span>}
      <span>{`${time.second}s`}</span>
    </div>
  )
}

export default Timer
